<template>
	<main>
        <div class="bg-grey" style="min-height: 100vh;">
            <header>
                <div class="container text-center">
                    <Logo outerClass="pt-2 pb-0 py-lg-3" color="_dark" innerClass="logo" type="png" />
                </div>
            </header>
            <section id="wizard" class="bg-grey py-3 py-lg-5">
                <div class="container">
                    <h2 class="d-none d-lg-block text-center mb-4">Your loan is moments away...</h2>
                    <router-view  />
                </div>
            </section>
        </div>
        <Footer />
	</main>
    
</template>

<script>
// @ is an alias to /src
import Logo from '@/components/Logo.vue';
import Footer from '@/components/Footer.vue';
import RouterView from 'vue-router';

export default {
  name: 'Wizard',
  components: {
    Logo,
    Footer,
  },
}
</script>